<template>
  <cus-dialog>
    <template v-slot:body>
      <div class="computer">
        <!-- 顯示欄位 -->
        <div class="compute-number">
          <div
            id="start"
            :class="['date-btn', selectBtn === 'start' ? 'date-btn-selected' : '']"
            @click="selectBtn = 'start'"
          >
            <p>
              <span v-for="num in 8" :key="num">
                <span :class="inputTurn.start.key === num - 1 ? 'line' : ''">
                  {{ computeNum.start.slice(num - 1, num) }}
                </span>
                <span v-if="num === 4 || num === 6">&nbsp;/&nbsp;</span>
              </span>
            </p>
          </div>
          <div>一</div>
          <div
            id="end"
            :class="['date-btn', selectBtn === 'end' ? 'date-btn-selected' : '']"
            @click="selectBtn = 'end'"
          >
            <p>
              <span v-for="num in 8" :key="num">
                <span :class="inputTurn.end.key === num - 1 ? 'line' : ''">
                  {{ computeNum.end.slice(num - 1, num) }}
                </span>
                <span v-if="num === 4 || num === 6">&nbsp;/&nbsp;</span>
              </span>
            </p>
          </div>
        </div>
        <!-- 數字鍵 -->
        <div class="number-button">
          <cus-button
            v-for="num in 9"
            :key="num"
            :text="num.toString()"
            @click="handleNumber(num)"
            :disabled="inputTurn[selectBtn].key === 8"
          ></cus-button>
          <cus-button
            text="0"
            style="grid-area: 4/1/5/3"
            @click="handleNumber(0)"
            :disabled="inputTurn[selectBtn].key === 8 || inputTurn[selectBtn].key === 0"
          ></cus-button>
          <cus-button
            topIcon="arrow-left"
            topIconClass="back-arrow"
            @click="handleBack"
            :disabled="inputTurn[selectBtn].back === 8"
          ></cus-button>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button
          text="確定"
          color="blue"
          :width="50"
          @click="submit(computeNum)"
          :disabled="computeNum.start === '00000000' || computeNum.end === '00000000'"
        ></cus-button>
      </div>
    </template>
  </cus-dialog>
</template>
<script>
import { ref, inject } from 'vue';
export default {
  name: 'date-range-picker',
  setup() {
    // const { proxy } = getCurrentInstance();
    //接受provide值
    const dialogVisible = inject('dialogVisible', false);
    const close = inject('close');
    const submit = inject('submit');
    const { cusProps } = inject('cusProps');
    //設定參數
    const day1 = new Date();
    const day2 = new Date(new Date().setFullYear(day1.getFullYear() - 1));
    //設定初始值
    const computeNum = ref(null);
    const selectBtn = ref('start');
    const inputTurn = ref(null);
    if (dialogVisible) {
      if (cusProps.init) computeNum.value = JSON.parse(JSON.stringify(cusProps.init));
      else {
        computeNum.value = {
          start: day2.getLocalDateTime('date').split('-').join(''),
          end: day1.getLocalDateTime('date').split('-').join(''),
        };
      }
      inputTurn.value = {
        start: {
          key: 2,
          back: 8,
        },
        end: {
          key: 2,
          back: 8,
        },
      };
    }

    //按數字
    const handleNumber = (num) => {
      computeNum.value[selectBtn.value] =
        computeNum.value[selectBtn.value].slice(0, inputTurn.value[selectBtn.value].key) +
        num +
        computeNum.value[selectBtn.value].slice(inputTurn.value[selectBtn.value].key + 1);
      inputTurn.value[selectBtn.value].key += 1;
      inputTurn.value[selectBtn.value].back -= 1;
    };
    //消除數字
    const handleBack = () => {
      computeNum.value[selectBtn.value] =
        computeNum.value[selectBtn.value].slice(0, inputTurn.value[selectBtn.value].key - 1) +
        0 +
        computeNum.value[selectBtn.value].slice(inputTurn.value[selectBtn.value].key);
      inputTurn.value[selectBtn.value].key -= 1;
      inputTurn.value[selectBtn.value].back += 1;
    };
    return {
      close,
      submit,
      computeNum,
      selectBtn,
      inputTurn,
      handleNumber,
      handleBack,
    };
  },
};
</script>
<style lang="scss" scoped>
.computer {
  @include computer-basic;
}
.compute-number {
  align-items: center;
  padding: 4px;
  .date-btn {
    width: 140px;
    height: 100%;
    text-align: center;
    background-color: $color-gray-3;
    border: 2px solid $color-gray-10;
    border-radius: 4px;
    font-size: 2.2rem;
    cursor: pointer;
    @include flex-center-center;
    transition: 0.2s;
    &-selected {
      background-color: $color-green;
      border: 2px solid $color-green;
      color: #fff;
    }
    .line {
      display: inline-block;
      position: relative;
      &::after {
        content: '';
        width: 100%;
        height: 2px;
        background-color: #fff;
        position: absolute;
        left: 0;
        bottom: 0;
        animation: blinker 1s linear infinite;
      }
    }

    @keyframes blinker {
      0% {
        opacity: 0;
      }
      30% {
        opacity: 1;
      }
      70% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }
}
</style>
